import React from 'react'

export default function FaceFeature({ fill, outline }) {
  return (
    <g>
      <path
        d="M38.85 4.05995C42.71 7.16995 46.37 14.67 42.14 29.95C37.9 45.23 21.13 62.26 5.5 54.01C5.5 54.01 14.47 54.93 14.44 42.32C14.42 29.7 13.32 15.96 19.89 7.57997C26.46 -0.800034 35.46 1.32995 38.85 4.05995Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.60986 54.92C8.60986 54.92 17.9699 55.65 20.6699 45.51C25.1799 28.5 22.2099 8.35002 32.9499 3.90002C32.9499 3.90002 34.3299 9.41001 32.9999 25.26C32.1199 35.79 27.3299 57.24 11.7499 55.75"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
